import { isDefined } from "@clipboard-health/util-ts";
import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { differenceInDays } from "date-fns";

import { useGetPayoutSettings } from "../../../../../Accounts/PayoutSettings/api/useGetPayoutSettings";
import { getSuggestInstantPayStorageKey, type SuggestInstantPayDismissalState } from "../types";
import { useSuggestInstantPayConfig } from "./useSuggestInstantPayConfig";

export function useShouldShowSuggestInstantPay(props: { isInstantPayShift: boolean }) {
  const { isInstantPayShift } = props;
  const { userId } = useDefinedWorker();
  const config = useSuggestInstantPayConfig();

  const [dismissalState] = useLocalStorage<SuggestInstantPayDismissalState>(
    getSuggestInstantPayStorageKey(userId),
    {}
  );

  const { data: payoutSettings } = useGetPayoutSettings({
    includeExternalAccount: true,
  });

  const canSwitchToInstantPayWithCurrentPayoutDestination =
    payoutSettings?.attributes.payoutSchedule === "standard" &&
    payoutSettings?.meta.payoutCapability === "instant" &&
    payoutSettings?.destinationDetails?.supportsInstantPayouts;

  function getIsDismissed() {
    if (dismissalState.permanentlyDismissed) {
      return true;
    }

    if (!isDefined(dismissalState.lastDismissedAt)) {
      return false;
    }

    if (config.recurring) {
      return (
        differenceInDays(new Date(), new Date(dismissalState.lastDismissedAt)) <
        config.cooldownInDays
      );
    }

    return true;
  }

  const isDismissed = getIsDismissed();

  return (
    config.enabled &&
    isInstantPayShift &&
    canSwitchToInstantPayWithCurrentPayoutDestination &&
    !isDismissed
  );
}
